import styled from 'styled-components'

export const ScheduleMeetingWrapper = styled.div`
  margin: 0;
  .scheduleWrap {
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
    padding: 25px 20px;
    border-radius: 10px;
    background: #ffffff;
    width: 100%;
    max-width: 1024px;
    margin: -50px auto 0;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    justify-content: center;
    gap: 30px;
    img {
      width: 100%;
      max-width: 200px;
    }
  }
  @media only screen and (min-width: 1200px) {
    margin: 20px;
  }
`
export const EarnedSectionWrapper = styled.div`
  background: linear-gradient(180deg, #5bbab9 0%, #52b4f9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
  padding: 40px 20px 80px;
  text-align: center;
  color: #fff;
  font-weight: 700;
  font-size: 30px;
  line-height: 38px;
`

export const ScheduleCategoriesWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 10px;
  display: grid;
  width: 100%;
  align-items: center;
  justify-content: center;
  .categoriesList {
    border: 1px solid #d4d4d8;
    border-radius: 4px;
    background: #fafafa;
    padding: 20px;
  }
  .Dot {
    width: 30px;
    height: 30px;
    border-radius: 100px;
  }
`

export const GuideWrapper = styled.div`
  .posDetail {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    width: 100%;
    max-width: 100%;
  }
  .posLeftRightPadding {
    padding: 0 20px;
  }
  @media only screen and (min-width: 668px) {
    .posLeftRightPadding {
      padding: 0 80px;
    }
  }
  @media only screen and (max-width: 992px) {
    .posDetail {
      width: 100%;
      max-width: 400px;
    }
  }
  @media only screen and (min-width: 992px) {
    .posDetail {
      width: 100%;
      max-width: 100%;
    }
  }
`

export const CardWrapper = styled.main.attrs({
  className:
    'bg-white shadow-lg rounded-xl border border-primary-outline px-7 py-12 h-[450px] flex flex-col justify-center items-center',
})``
